"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateZipCodeInput = exports.setZipStatusIconState = exports.isValidZip = void 0;
var state_1 = require("../state");
var isValidZip = function (zip) { return /^\d{5}(-\d{4})?$/.test(zip); };
exports.isValidZip = isValidZip;
var zipCodeElement = document.getElementById('zip-code');
var setZipStatusIconState = function (state) {
    var zipCodeStatusIcon = document.querySelector('.FAForm__zipInput__status');
    if (!zipCodeStatusIcon) {
        return false;
    }
    if (state === 'pending') {
        zipCodeStatusIcon.classList.remove('is-hidden');
        zipCodeStatusIcon.classList.remove('is-valid');
        return true;
    }
    if (state === 'valid') {
        zipCodeStatusIcon.classList.add('is-valid');
        zipCodeStatusIcon.classList.remove('is-hidden');
        return true;
    }
    // Default to hidden
    zipCodeStatusIcon.classList.remove('is-valid');
    zipCodeStatusIcon.classList.add('is-hidden');
    return true;
};
exports.setZipStatusIconState = setZipStatusIconState;
var zipCodeHandler = function () {
    if (!zipCodeElement) {
        return false;
    }
    var zipCodeChangeHandler = function (e) {
        e.preventDefault();
        var value = zipCodeElement.value;
        if (exports.isValidZip(value)) {
            state_1.setState({ zipCode: value });
            return true;
        }
        state_1.setState({ zipCode: null });
        exports.setZipStatusIconState('hidden');
        console.error('Not a valid zipcode');
        return false;
    };
    zipCodeElement.addEventListener('focusout', zipCodeChangeHandler);
};
var formEventHandler = function () { return (Array.from(document.querySelectorAll('[data-advisor] form')).map(function (form) { return form.addEventListener('submit', function (e) { return e.preventDefault(); }); })); };
exports.default = (function () {
    zipCodeHandler();
    formEventHandler();
});
var ValidateZipCodeInput = function () { return (zipCodeElement ? exports.isValidZip(zipCodeElement.value) : false); };
exports.ValidateZipCodeInput = ValidateZipCodeInput;
